import { render, staticRenderFns } from "./DashboardSavingsOverview.vue?vue&type=template&id=6619bcda&"
import script from "./DashboardSavingsOverview.vue?vue&type=script&lang=js&"
export * from "./DashboardSavingsOverview.vue?vue&type=script&lang=js&"
import style0 from "./DashboardSavingsOverview.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports